/**
 * Maps the apply-wizard form values to the pro-api BorrowerApplicationRequest shape.
 */
function toDateString(value) {
  if (!value) return undefined;
  if (typeof value === 'string') return value;
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString().slice(0, 10);
  }
  // dayjs / luxon-like
  if (typeof value?.format === 'function') return value.format('YYYY-MM-DD');
  if (typeof value?.toISOString === 'function') {
    try {
      return value.toISOString().slice(0, 10);
    } catch {
      return undefined;
    }
  }
  return undefined;
}

export function mapApplicationPayload(form) {
  const pi = form?.personalInfo || {};
  const emp = form?.employment || {};
  const assets = form?.assets || {};
  const liab = form?.liabilities || {};
  const prop = form?.property || {};
  const loan = form?.loanDetails || {};
  const decl = form?.declarations || {};

  return {
    personal: {
      firstName: pi.firstName,
      lastName: pi.lastName,
      email: pi.email,
      phone: pi.phone,
      dateOfBirth: toDateString(pi.dateOfBirth),
      maritalStatus: pi.maritalStatus,
      citizenship: pi.citizenship,
      addressLine1: pi.currentAddress,
      city: pi.currentCity,
      state: pi.currentState,
      zip: pi.currentZip,
      yearsAtAddress: pi.yearsAtAddress,
      housingStatus: pi.housingStatus,
      monthlyHousingPayment: pi.monthlyRent,
    },
    employment: {
      employerName: emp.employerName,
      position: emp.position,
      employerPhone: emp.employerPhone,
      yearsEmployed: emp.yearsEmployed,
      startDate: toDateString(emp.employmentStartDate),
      selfEmployed: !!emp.selfEmployed,
      baseIncome: emp.baseIncome,
      overtime: emp.overtime,
      bonus: emp.bonus,
      commission: emp.commission,
      otherIncome: emp.otherIncome,
      totalMonthlyIncome: emp.totalMonthlyIncome,
    },
    assets: {
      checking: assets.checkingAccounts,
      savings: assets.savingsAccounts,
      retirement: assets.retirementAccounts,
      other: assets.otherAssets,
      giftFunds: assets.giftFunds,
      giftSource: assets.giftSource,
      totalAssets: assets.totalAssets,
    },
    liabilities: {
      creditCards: liab.creditCardDebt,
      autoLoans: liab.carLoans,
      studentLoans: liab.studentLoans,
      other: liab.otherDebts,
      alimony: liab.alimonyChildSupport,
      totalMonthlyDebt: liab.totalMonthlyDebt,
    },
    property: {
      addressLine1: prop.address,
      city: prop.city,
      state: prop.state,
      zip: prop.zip,
      county: prop.county,
      propertyValue: prop.propertyValue,
      propertyType: prop.propertyType,
      occupancy: prop.occupancyType,
      units: prop.unitsCount,
    },
    loanDetails: {
      purpose: loan.loanPurpose,
      loanType: loan.loanType,
      loanAmount: loan.loanAmount,
      downPayment: loan.downPayment,
      currentBalance: loan.currentMortgageBalance,
      currentRate: loan.currentInterestRate,
      cashOut: !!(loan.cashOutAmount && Number(loan.cashOutAmount) > 0),
      refinancePurpose: loan.refinancePurpose,
    },
    declarations: {
      outstandingJudgments: !!decl.outstandingJudgments,
      bankruptcy: !!decl.bankruptcyLast7Years,
      foreclosure: !!decl.foreclosureLast7Years,
      lawsuit: !!decl.lawsuitParty,
      federalDebt: !!decl.delinquentFederalDebt,
      alimonyObligation: !!decl.alimonyObligation,
      borrowedDownPayment: !!decl.downPaymentBorrowed,
      usCitizen: !!decl.usCitizen,
      permanentResident: !!decl.permanentResident,
      militaryService: !!(decl.currentlyServing || decl.previouslyServed),
    },
  };
}
